import { SSE } from 'sse.js';

class SseEventSource {
  public async getSseEventSource(
    url: string,
    userContext: any,
    payload: any,
    callback: (event: string, payload: any) => void,
  ) {
    const accessToken = await userContext.getAccessToken();
    var source = new SSE(`${import.meta.env.VITE_CORE_API_BASE_URL}${url}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
      payload: JSON.stringify(payload),
    });

    let timer = this.startTimer(source, callback);
    source.addEventListener('message', (event: any) => {
      clearTimeout(timer);
      timer = this.startTimer(source, callback);
      if (event.data) {
        try {
          const payload = JSON.parse(event.data);
          callback('message', payload);
        } catch (error) {
          console.log(error);
        }
      }
    });

    source.addEventListener('status', (event: any) => {
      clearTimeout(timer);
      timer = this.startTimer(source, callback);
      if (event.data) {
        try {
          const payload = JSON.parse(event.data);
          callback('status', payload);
        } catch (error) {
          console.log(error);
        }
      }
    });

    source.addEventListener('error', function (event: any) {
      clearTimeout(timer);
      source.close();
      if (event.data) {
        try {
          const payload = JSON.parse(event.data);
          callback('error', payload);
        } catch (error: any) {
          callback('error', { message: error.message });
        }
      } else {
        callback('error', { message: 'An error has occured' });
      }
    });

    source.addEventListener('close', function (event: any) {
      clearTimeout(timer);
      source.close();
      if (event.data) {
        try {
          const payload = JSON.parse(event.data);
          callback('close', payload);
        } catch (error: any) {
          callback('close', {});
        }
      } else {
        callback('close', {});
      }
    });

    return source;
  }

  private startTimer(source: SSE, callback: (event: string, payload: any) => void) {
    return setTimeout(() => {
      if (source.readyState !== source.CLOSED) {
        source.close();
        callback('error', 'Request timed out');
      }
    }, 300000); // 5 minutes timeout
  }
}

export default SseEventSource;
